export const GET_CURRENT_RECEIPT = 'GET_CURRENT_RECEIPT';
export const SET_CHOSEN_RECEIPT = 'SET_CHOSEN_RECEIPT';
export const GET_CLIENT_INFO = 'GET_CLIENT_INFO';
export const GET_PHARMACIST_TODAY_BONUSES = 'GET_PHARMACIST_TODAY_BONUSES';
export const GET_CLIENT_ORDERS = 'GET_CLIENT_ORDERS';
export const APPLY_BONUSES = 'APPLY_BONUSES';
export const SUBMIT_LOYALTY_ORDER = 'SUBMIT_LOYALTY_ORDER';
export const SET_PARTNER_PAYMENT_METHOD = 'SET_PARTNER_PAYMENT_METHOD';
export const SET_IN_PLACE_PAYMENT_METHOD = 'SET_IN_PLACE_PAYMENT_METHOD';
export const GET_PARTNER_PAYMENTS = 'GET_PARTNER_PAYMENTS';

export const SEND_TO_STANDARD = 'SEND_TO_STANDARD';
export const GET_HEALTH_STATUS = 'GET_HEALTH_STATUS';

export const RESET_CLIENT_INFO = 'RESET_CLIENT_INFO';
export const RESET_CURRENT_RECEIPT = 'RESET_CURRENT_RECEIPT';
export const RESET_APPLY_BONUSES = 'RESET_APPLY_BONUSES';
export const RESET_SUBMIT_ORDER = 'RESET_SUBMIT_ORDER';

export const GENERATE_LOYALTY_REPORT = 'GENERATE_LOYALTY_REPORT';

export const ADD_LOYALTY_PRODUCT = 'ADD_LOYALTY_PRODUCT';
export const GET_LOYALTY_PRODUCTS = 'GET_LOYALTY_PRODUCTS';
export const DELETE_LOYALTY_PRODUCT = 'DELETE_LOYALTY_PRODUCT';

export const GET_LOYALTY_PERCENTAGES = 'GET_LOYALTY_PERCENTAGES';

export const CREDIT_BONUSES = 'CREDIT_BONUSES';
export const GET_RECOMMENDATIONS = 'GET_RECOMMENDATIONS';

export const SET_LOYALTY_INFO_BOT = 'SET_LOYALTY_INFO_BOT';
